import { Maybe } from 'graphql/jsutils/Maybe';

import { Box, CircularProgress, Typography } from '@mui/material';

import {
  styledAdditionalTotalText,
  styledReceiptAccordionChildrenWrapper,
  styledSectionTitle,
  styledTitlePrices,
} from './ReceiptTitleSection.styled';
import { styledCrossedPriceContent } from '../ReceiptDetailsTitleSection/ReceiptDetailsTitleSection.styled';

interface ReceiptTitleSectionProps {
  title: string;
  currency: Maybe<string>;
  price?: string;
  oldPrice?: string | number;
  additionalText?: string;
  loading?: boolean;
}

export default function ReceiptTitleSection({
  title,
  currency,
  price,
  oldPrice,
  additionalText,
  loading,
}: ReceiptTitleSectionProps) {
  const showOldPrice =
    oldPrice !== undefined && oldPrice !== null && oldPrice !== '';
  const showPrice =
    price !== undefined && price !== null && price !== '';

  return (
    <Box sx={styledReceiptAccordionChildrenWrapper}>
      <Box sx={styledSectionTitle}>
        <Typography fontWeight={700}>{title}</Typography>
        <Box sx={styledTitlePrices}>
          {loading ? (
            <CircularProgress size={16} />
          ) : (
            <>
              {showOldPrice && (
                <Typography sx={styledCrossedPriceContent}>
                  {currency}
                  {oldPrice}
                </Typography>
              )}
              {showPrice && (
                <Typography>
                  {currency}
                  {price}
                </Typography>
              )}
            </>)}
        </Box>
      </Box>
      {additionalText && (
        <Typography variant="body5" sx={styledAdditionalTotalText}>
          {additionalText}
        </Typography>
      )}
    </Box>
  );
}
